<a
  [routerLink]="blogItem.contentSlug"
  routerLinkActive="active-link"
  [routerLinkActiveOptions]="{ exact: true }"
  class="thumb"
>
  <span
    class="fullimage cover"
    role="img"
    [ngStyle]="{ 'background-image': 'url(' + blogItem.featureImageUrl + ')' }"
  ></span>
</a>
<div class="info">
  <time>{{ blogItem.contentPublishDate | date: 'dd MMM yyyy' }}</time>
  <h4 class="title usmall">
    <a [routerLink]="blogItem.contentSlug" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">{{
      blogItem.contentTitle
    }}</a>
  </h4>
</div>
<div class="clear"></div>
